import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import {
  colorBgButtonSubtleHovered,
  colorBgSuccessHovered,
  colorBgSucessBold,
  colorTextSubtle,
} from 'src/app/themes/primaryThemeDefault'
import { GreenDotIcon, GreyDotIcon, YellowWaringDotIcon } from 'src/assets/icons'
import { UPLOAD_STATUS_TYPE } from './constant'
import { Flex, Typography } from 'antd'
interface IPropsStatusTag {
  status: number | string
}

export const StatusTag: React.FC<IPropsStatusTag> = React.memo(({ status }) => {
  const { t } = useTranslation()

  const getTag = useCallback(():
    | { value: string; color: string; bgColor: string; dot: React.ReactElement; width: string }
    | undefined => {
    switch (status) {
      case 'Processed':
      case UPLOAD_STATUS_TYPE.PROCESSED:
        return {
          value: t(`ACHExceptionRule:uploadModal.uploadFile.errorDetails.processedStatus`),
          color: colorBgSucessBold,
          bgColor: colorBgSuccessHovered,
          width: '120px',
          dot: <GreenDotIcon style={{ minWidth: 5 }} />,
        }
      case 'Rejected':
      case UPLOAD_STATUS_TYPE.REJECTED:
        return {
          value: t(`ACHExceptionRule:uploadModal.uploadFile.errorDetails.rejectedStatus`),
          color: colorTextSubtle,
          bgColor: colorBgButtonSubtleHovered,
          width: '120px',
          dot: <GreyDotIcon style={{ minWidth: 5 }} />,
        }
      case 'Processed With Exception':
      case 'Processed With Exceptions':
      case UPLOAD_STATUS_TYPE.PROCESSED_WITH_EXCEPTIONS:
        return {
          value: t(`ACHExceptionRule:uploadModal.uploadFile.errorDetails.processedWithExceptionsStatus`),
          color: '#F8C100',
          bgColor: '#FFFAE7',
          width: '120px',
          dot: <YellowWaringDotIcon style={{ minWidth: 5 }} />,
        }
      default:
        return undefined
    }
  }, [status, t])

  return (
    <Flex justify='flex-start'>
      <Flex
        justify='center'
        align='center'
        gap={4}
        style={{
          backgroundColor: getTag()?.bgColor,
          borderRadius: 24,
          padding: '8px 14px',
        }}
      >
        {getTag()?.value && getTag()?.dot}
        <Typography.Text style={{ color: getTag()?.color, fontSize: '14px', fontWeight: 700, wordBreak: 'keep-all' }}>
          {getTag()?.value}
        </Typography.Text>
      </Flex>
    </Flex>
  )
})
